export default {"src":"/_next/static/media/cash.fec2f6d7.svg","height":80,"width":80};